import moment from "moment";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";



export const getVendorExpenseExcelData = (vendorList) => {
    let list = JSON.parse(JSON.stringify(vendorList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data.poNo),
        "Current Order Date": data.oDt && moment(data.oDt).format("DD-MMM-YYYY"),
        "Current Order Month": data.oM && poMonthFormate(data.oM),
        "Category": data.cat,
        "Major Type": data.mjId?.val,
        "Minor Type": data?.mnId?.val,
        "Minor Sub Category": data?.msId?.val,
        "Approved Amount":`₹ ${data.pyInfo?.tlAmt  ? formatAmountIndianRupees(data.pyInfo?.tlAmt) : Number(0).toFixed(2)}`,
        
    };
   
      

      return content;
    });
    return exportData;
  };